import React, { useState,useEffect } from 'react'
import { auth,signOut, signInWithPopup,googleAuthProvider,setPersistence,browserLocalPersistence } from '../firebase';
import './WeatherApp.css'
import GoogleButton from 'react-google-button'
import s_icon from '../Assets/search.png'
import c_icon from '../Assets/clear.png'
import h_icon from '../Assets/humidity.png'
import r_icon from '../Assets/rainfall.png'
import w_icon from '../Assets/wind.png'
import l_icon from '../Assets/light.png'
import snow_icon from '../Assets/snow.png'
import cloud_icon from '../Assets/cloud.png'
import scat_icon from '../Assets/scatter.png'
import haze_icon from '../Assets/haze.png'
import d_icon from '../Assets/drizzle.png'
import { Button } from '@mui/material';


const Weather = () => {
  let api_key="f6e20d2d035d3fde26202ba9278f0d13"
  const [wicon,setWicon]=useState(c_icon);
  const [user, setUser] = useState(null); // Initialize user as null
  
  useEffect(() => {
    setPersistence(auth, browserLocalPersistence)
    .then(() => {
      // Now, configure Firebase for persistent login
      if (auth.currentUser) {
        setUser(auth.currentUser);
      }
      
    })
    .catch((error) => {
      console.error(error.message);
    });
}, []);

  
  const search=async ()=>{
    const element = document.getElementsByClassName('cityInput')[0]; 
   

    if (element.value === '') { // Check if the input field is empty
      let a = 'Wow you are so smart🥲';
      let b = 'Please enter a city name';
      alert(a + '\n' + b);
      return;
    }
    if (user) {
    if(element.value){
      let city=element.value
      let url=`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${api_key}&units=metric`
      let response=await fetch(url)
      let data=await response.json()
      const humidity=document.getElementsByClassName('humidity-percent')
      const wind=document.getElementsByClassName('wind')
      const temp=document.getElementsByClassName('weather-temp')
      const location=document.getElementsByClassName('weather-location')
      humidity[0].innerHTML=data.main.humidity+'%'
      wind[0].innerHTML=data.wind.speed+'km/h'
      temp[0].innerHTML=data.main.temp+'° C'
      location[0].innerHTML=data.name

      const iconMapping = {
        '01d': c_icon,
        '01n': c_icon,
        '02d': cloud_icon,
        '02n': cloud_icon,
        '03d': scat_icon,
        '03n': scat_icon,
        '04d': cloud_icon,
        '04n': cloud_icon,
        '09d': d_icon,
        '09n':d_icon ,
        '10d': r_icon,
        '10n': r_icon,
        '11d': l_icon,
        '11n': l_icon,
        '13d': snow_icon,
        '13n': snow_icon,
        '50d': haze_icon,
        '50n': haze_icon,
      };
      
      if (data.weather[0].icon in iconMapping) {
        setWicon(iconMapping[data.weather[0].icon]);
      } else {
        console.log('Icon not found');
        setWicon(c_icon); 
      }

    }
    
  }
  else{
    alert("Please log in to use this feature 😊")
  }
    

  }


  const handleGoogleSignOut = () => {
    signOut(auth)
      .then(() => {
        setUser(null);
      })
      .catch((error) => {
        alert(error.message);
      });
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      search();
    }
  };
  
   
  
  const handleGoogleSignIn = () => {
    signInWithPopup(auth, googleAuthProvider)
      .then((result) => {
        const user = result.user;
        
     
        setUser(user);
      })
      .catch((error) => {
        const errorMessage = error.message;
        alert(errorMessage);
      });
  }
  

  return (
        <>
        <GoogleButton className='gbtn'  onClick={handleGoogleSignIn} style={{ display: user ? 'none' : 'block' }} />
        <Button className='logout' onClick={handleGoogleSignOut} style={{ display: user ? 'block' : 'none' }}>Logout</Button>
        
        
    <div className='container'>
        <div className="top-bar">
            <input type="text" className='cityInput' placeholder='Enter city' onKeyDown={handleKeyPress}/>
            <div className="search-icon" onClick={()=>{search()}}>
                <img src={s_icon} alt="search-btn" />
            </div>

        </div>

    <div className="weather-image">
        <img src={wicon} alt="cloud" />
    </div>
    <div className="weather-temp">--° C</div>
    <div className="weather-location">---🙂---</div>
    <div className="data-container">
      <div className='element'>
        <img src={h_icon} className='icon' alt="" />
        <div className='data'>
              <div className="humidity-percent">--%</div>
              <div className="text">Humidity</div>
        </div>
      </div>
      <div className='element'>
        <img src={w_icon} className='icon' alt="" />
        <div className='data'>
              <div className="wind">--km/h</div>
              <div className="text">Wind Speed</div>
        </div>
      </div>
    </div>
    </div>
  </>

  )
}
export default Weather;
